import screenService from '../services/ScreenService';

declare module 'vue/types/vue' {
  interface Vue {
    $screen: typeof screenService;
  }
}

const ScreenServicePlugin = {
  install(VueInstance: any) {
    VueInstance.prototype.$screen = screenService;
    VueInstance.mixin({
      computed: {
        $isMobile(): boolean {
          return this.$screen.isMobile();
        },
      },
    });
  },
};

export default ScreenServicePlugin; 